import { createSlice } from '@reduxjs/toolkit'
import { isDarkMode } from 'utils/helpers'

const initialState = {
  confirmModal: {
    isOpen: false,
    onSave: '',
    onCancel: null,
    cancelText: null,
  },
  isSidebarOpen: false,
  isMobileSidebarOpen: false,
  isLoadingAuth: false,
  darkMode: isDarkMode,
}

const globalSlice = createSlice({
  name: 'globalStates',
  initialState,
  reducers: {
    setConfirmModal: (state, { payload }) => {
      state.confirmModal = payload
    },
    changeTheme: (state) => {
      localStorage.setItem('darkMode', String(!state.darkMode))
      state.darkMode = !state.darkMode
    },
    setLoadingAuth: (state, { payload }) => {
      state.isLoadingAuth = payload
    },
    toggleSideBar: (state, { payload }: { payload?: boolean }) => {
      if (payload) {
        state.isSidebarOpen = payload
      } else {
        state.isSidebarOpen = !state.isSidebarOpen
      }
    },
    setSidebarOpen: (state, { payload }) => {
      state.isSidebarOpen = payload
    },
    setMobileSidebar: (state, { payload }: { payload: boolean }) => {
      state.isMobileSidebarOpen = payload
    },
    toggleMobileSidebar: (state) => {
      state.isMobileSidebarOpen = !state.isMobileSidebarOpen
    },
  },
  extraReducers: {},
})

export const {
  setConfirmModal,
  setLoadingAuth,
  toggleSideBar,
  setSidebarOpen,
  changeTheme,
  setMobileSidebar,
  toggleMobileSidebar,
} = globalSlice.actions
export default globalSlice.reducer
